import React from 'react';
import { useLanguage } from './LanguageContext';
import { motion } from 'framer-motion';
import { MapPinIcon, VideoIcon, LanguagesIcon, HeartHandshakeIcon } from 'lucide-react';
import { artwork } from './artwork';
export function Hero() {
  const {
    t
  } = useLanguage();
  const badges = [{
    icon: <MapPinIcon size={16} data-id="element-135" />,
    text: t.hero.badges.location
  }, {
    icon: <VideoIcon size={16} data-id="element-136" />,
    text: t.hero.badges.virtual
  }, {
    icon: <LanguagesIcon size={16} data-id="element-137" />,
    text: t.hero.badges.languages
  }, {
    icon: <HeartHandshakeIcon size={16} data-id="element-138" />,
    text: t.hero.badges.trauma
  }];
  return <section id="home" className="relative pt-32 pb-20 md:pt-48 md:pb-32 overflow-hidden bg-teal-50/50" data-id="element-139">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-140">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-teal-100/40 blur-3xl" data-id="element-141" />
        <div className="absolute top-[40%] -left-[10%] w-[50%] h-[50%] rounded-full bg-teal-50/60 blur-3xl" data-id="element-142" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-143">
        <div className="grid xl:grid-cols-2 gap-12 xl:gap-8 items-center" data-id="element-144">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="max-w-2xl mx-auto xl:mx-0 text-center xl:text-left" data-id="element-145">
            <p className="sm:text-xl font-medium text-teal-600 mb-2 tracking-wide text-[28px]" data-id="element-146">
              The Hope Circle
            </p>
            <h1 className="sm:text-[40px] xl:text-[50px] text-slate-800 mb-6 font-[400] text-[36px] font-[Cinzel,_serif]" data-id="element-147">
              {'Midwifery & Maternity Care Auckland & Online'}
            </h1>
            <p className="text-lg sm:text-xl text-slate-600 mb-8 leading-relaxed" data-id="element-148">
              {t.hero.subheadline}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-12 justify-center xl:justify-start" data-id="element-149">
              <a href="#contact" className="inline-flex justify-center items-center bg-teal-600 hover:bg-teal-700 text-white px-8 py-3.5 rounded-full text-base font-medium transition-all shadow-sm hover:shadow-md hover:-translate-y-0.5" data-id="element-150">
                {t.hero.ctaBook}
              </a>
              <a href="#services" className="inline-flex justify-center items-center bg-white hover:bg-slate-50 text-teal-700 border border-teal-100 px-8 py-3.5 rounded-full text-base font-medium transition-all shadow-sm hover:shadow-md hover:-translate-y-0.5" data-id="element-151">
                {t.hero.ctaServices}
              </a>
            </div>

            {/* Badges */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-lg mx-auto xl:mx-0 xl:max-w-none" data-id="element-152">
              {badges.map((badge, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -10
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.5,
              delay: 0.4 + index * 0.1
            }} className="flex items-center space-x-3 bg-white/80 backdrop-blur-sm px-4 py-2.5 rounded-xl border border-teal-50 shadow-sm" data-id="element-153">
                  <div className="text-teal-600 bg-teal-50 p-1.5 rounded-lg" data-id="element-154">
                    {badge.icon}
                  </div>
                  <span className="text-sm font-medium text-slate-700" data-id="element-155">
                    {badge.text}
                  </span>
                </motion.div>)}
            </div>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative mx-auto w-full max-w-xs xl:max-w-sm" data-id="element-156">
            <div className="aspect-square rounded-full overflow-hidden shadow-2xl relative border-8 border-white" data-id="element-157">
              <img src="https://cdn.magicpatterns.com/uploads/1YxhsevnEBCR4HPfgouLr2/a1375-cropped-cropped-cropped-design_sans_titre__1_-removebg-preview-e1722436076517.png" alt="Turquoise Logo Artwork" className="object-cover w-full h-full" data-id="element-158" />
              <div className="absolute inset-0 bg-teal-900/5 mix-blend-multiply rounded-full" data-id="element-159"></div>
            </div>

            {/* Decorative element */}
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-teal-100 rounded-full -z-10 blur-2xl" data-id="element-160"></div>
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-teal-200 rounded-full -z-10 blur-2xl" data-id="element-161"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}